import React from 'react';
import { Link } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import NewPasswordForm from './NewPasswordForm';

import Logo from '../../assets/images/puntu-logo2.svg';

const styles = theme => ({
  container: {
    minHeight: '100vh',
    height: 'auto',
    padding: theme.spacing(4),
  },
  logo: {
    width: '40px',
  },
});

const NewPassword = ({ classes, loading, onNewPassword }) => (
  <Grid container justify="center" className={classes.container}>
    <Grid container>
      <Link to="/login">
        <img src={Logo} alt="Puntu" className={classes.logo} />
      </Link>
    </Grid>

    <Grid item xs={12} sm={8} md={6} container direction="column">
      <Grid item>
        <Typography variant="h5" color="textSecondary" gutterBottom>
          Redefina sua senha.
        </Typography>
      </Grid>
      <Grid item>
        <NewPasswordForm onNewPassword={onNewPassword} loading={loading} />
      </Grid>
    </Grid>
  </Grid>
);

export default withStyles(styles)(NewPassword);
